//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/RoutingCommon.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.OrientXpressBuilder.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"ActiveTransformType",1,0],[0,"ConstrainedPoint",1,"Point",0],[0,"InitialOrientation",1,0],[0,"InitialPosition",1,0],[1,"OrientExpress",0,"GeometricUtilities.OrientXpressBuilder",0],[0,"Plane",1,"Plane",0],[0,"TempOrientation",1,0],[0,"TempPosition",1,0],[0,"Vector",1,"Direction",0]],[],[]];
SPLM.RoutingCommon.TransformBlockBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.RoutingCommon.TransformBlockBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.RoutingCommon.TransformBlockBuilder.Transformtype = Object.freeze({
    "None" : "None", "OrientXpress" : "OrientXpress", "Vector" : "Vector", "View" : "View", "Manipulator" : "Manipulator", "Plane" : "Plane"});

export default SPLM;